module.exports = __WEBPACK_EXTERNAL_MODULE_143__;


//////////////////
// WEBPACK FOOTER
// external "@jupyter-widgets/base"
// module id = 143
// module chunks = 0